import clsx from "clsx";
import firebase from "firebase/compat/app";
import { FC, useEffect, useState } from "react";
import db from "../../../db";

const { Timestamp } = firebase.firestore;

const MarketplaceCategoryTab: FC = () => {
  const [files, setFiles] = useState("");
  const [isShopeeProductCategoryExist, setIsShopeeProductCategoryExist] =
    useState<boolean>(false);
  const [isSubmitClicked, setIsSubmitClicked] = useState<boolean>(false);

  const insertShopeeProductCategoryHandler = async (e: any) => {
    const fileReader: any = new FileReader();
    fileReader.readAsText(e.target.files[0], "UTF-8");
    fileReader.onload = (e: any) => {
      console.log("e.target.result", e.target.result);
      setFiles(e.target.result);
    };
  };

  const handleAddShopee = async (data: any) => {
    setIsSubmitClicked(true);
    let converted: any = JSON.parse(data);
    // check if shopee exist
    const doesDocExist = (docId: string) => {
      return db
        .collection("marketplaceProductCategory")
        .doc(docId)
        .get()
        .then((doc) => {
          return doc.exists;
        });
    };
    //Call the function to check if doc exists:
    let isShopeeExist = await doesDocExist("Shopee");

    if (isShopeeExist) {
      console.log("DATA IS ALREADY EXIST");
      return;
    } else {
      console.log("PERFORM ADD DATA");
      //if not exist, insert
      const categoryList = converted.response.category_list;
      db.collection("marketplaceProductCategory")
        .doc("shopee")
        .set({
          name: "shopee",
          isActive: true,
          createdAt: Timestamp.now(),
          updatedAt: Timestamp.now(),
        })
        .then((docRef: any) => {
          categoryList.forEach((category: any) => {
            let categoryId = category.category_id;
            db.collection("marketplaceProductCategory")
              .doc("shopee")
              .collection("categoryList")
              .doc(categoryId.toString())
              .set(
                {
                  categoryId: category.category_id.toString(),
                  isActive: true,
                  parentCategoryId: category.parent_category_id.toString(),
                  categoryName: {
                    id: category.display_category_name,
                    en: category.original_category_name,
                  },
                  hasChildren: category.has_children,
                  createdAt: Timestamp.now(),
                  updatedAt: Timestamp.now(),
                },
                { merge: true }
              );
          });
        });
    }
  };

  console.log("EXIST STATE", isShopeeProductCategoryExist);
  useEffect(() => {
    db.collection("marketplaceProductCategory")
      .doc("shopee")
      .get()
      .then((doc) => {
        setIsShopeeProductCategoryExist(doc.exists);
      });
  }, [isShopeeProductCategoryExist]);

  const handleToLowerCaseShopee = async () => {
    setIsSubmitClicked(true);
    const getShopeeData = await db
      .collection("marketplaceProductCategory")
      .doc("Shopee")
      .get()
      .then((doc) => {
        console.log("doc : ", doc.data());
        return doc.data();
      });
    const getShopeeCategoryData = await db
      .collection("marketplaceProductCategory")
      .doc("Shopee")
      .collection("categoryList")
      .get()
      .then((snapshot) => {
        const categories = snapshot.docs.map((doc) => {
          return { ...doc.data(), id: doc.id };
        });
        return categories;
      });
    if (getShopeeData) {
      console.log("getShopeeData : ", getShopeeData);
      const updateShopee = await db
        .collection("marketplaceProductCategory")
        .doc("shopee")
        .set({
          name: "shopee",
          isActive: true,
          createdAt: getShopeeData.createdAt,
          updatedAt: getShopeeData.updatedAt,
        })
        .then((docRef: any) => {
          console.log("docRef : ", docRef);
          if (getShopeeCategoryData) {
            console.log("getShopeeCategoryData : ", getShopeeCategoryData);
            getShopeeCategoryData.map(async (category: any) => {
              console.log("category : ", category);
              let categoryId = category.id;
              console.log("categoryId : ", categoryId);
              const shopeeCategoryList = await db
                .collection("marketplaceProductCategory")
                .doc("shopee")
                .collection("categoryList")
                .doc(categoryId)
                .set(category);
              console.log("shopeeCategoryList : ", shopeeCategoryList);
            });
          }
        });
      setIsSubmitClicked(false);
    }
  };

  return (
    <div>
      <div>
        <h1>Shopee</h1>
        <input
          type="file"
          accept="application/json"
          onChange={insertShopeeProductCategoryHandler}
        />
        <button
          className={clsx("btn btn-primary mp-3", { disabled: !files })}
          onClick={() => (files ? handleAddShopee(files) : "")}
        >
          Submit
        </button>
      </div>
      <div>
        <button
          className={clsx("btn btn-primary mp-3")}
          onClick={() => handleToLowerCaseShopee()}
        >
          Update Shopee To shopee
        </button>
      </div>
      <div>
        {isShopeeProductCategoryExist && isSubmitClicked && (
          <p>Shopee Product Category is Already Exist</p>
        )}
      </div>
    </div>
  );
};

export default MarketplaceCategoryTab;
